import React from "react";
import { Link } from "gatsby";

const FooterLegal = (props) => (
  <>
    {props.isSpanish ? (
      <div id="footer-legal-spanish" className="col-md-9 col-xl-10">
        <p className="text-muted text-sm mb-3">
          WaFd Bank es un DBA (Doing Business As) del Washington Federal Bank, Asociación Nacional.
        </p>
        <p className="text-muted text-sm mb-3">
          &copy; {new Date().getFullYear()}, WaFd Bank, Todos los derechos reservados. Compañía NMLSR #410394
          <br className="d-inline d-lg-none" />
          <Link id="bfl-terms-of-use" to="/es/terminos-de-uso" className="ml-lg-3">
            Termino de Uso
          </Link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <Link id="bfl-privacy-security" to="/es/privacidad-y-seguridad">
            Privacidad y Seguridad
          </Link>
        </p>
      </div>
    ) : (
      <div id="footer-legal" className="col-md-9 col-xl-10">
        <p className="text-muted text-sm mb-3">
          WaFd Bank is a DBA (Doing Business As) of Washington Federal Bank, National Association.
        </p>
        <p className="text-muted text-sm mb-3">
          &copy; {new Date().getFullYear()}, WaFd Bank, All Rights Reserved. NMLSR Company #410394
          <br className="d-inline d-lg-none" />
          <Link id="bfl-terms-of-use" to="/terms-of-use" className="ml-lg-3">
            Terms of Use
          </Link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <Link id="bfl-privacy-security" to="/banking-privacy-security">
            Privacy &amp; Security
          </Link>
        </p>
      </div>
    )}
  </>
);

export default FooterLegal;
